import { useEffect, useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, Paper, Typography, LinearProgress } from "@material-ui/core";
import api from "../services/api";

/**
 * Histórico de modificações de uma reunião: quem fez, o que mudou, dia e horário.
 * Lê GET agendamento-lead/{id}/historico. "versao" muda depois de cada gravação na tela
 * para recarregar a lista.
 */
const HistoricoModificacoes = ({ agendamentoId, versao = 0 }) => {
    const [linhas, setLinhas] = useState([]);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState(false);

    useEffect(() => {
        if (!agendamentoId) return;
        let ativo = true;
        setCarregando(true);
        setErro(false);
        api.get(`agendamento-lead/${agendamentoId}/historico`)
            .then(({ data }) => { if (ativo) setLinhas(Array.isArray(data) ? data : []); })
            .catch(() => { if (ativo) setErro(true); })
            .finally(() => { if (ativo) setCarregando(false); });
        return () => { ativo = false; };
    }, [agendamentoId, versao]);

    if (!agendamentoId) return null;

    return (
        <div style={{ marginTop: 30 }}>
            <Typography variant="h6" component="h2" style={{ marginBottom: 8 }}>
                Histórico de modificações
            </Typography>
            {carregando && <LinearProgress />}
            {erro && <div style={{ color: "#8E2F12" }}>Não foi possível carregar o histórico.</div>}
            {!carregando && !erro && linhas.length === 0 && (
                <div style={{ color: "#666", fontSize: 14 }}>
                    Nenhuma modificação registrada. O histórico começa a contar a partir da atualização de 04/11/2026.
                </div>
            )}
            {linhas.length > 0 && (
                <Paper variant="outlined" style={{ overflowX: "auto" }}>
                    <Table size="small" aria-label="Histórico de modificações">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ whiteSpace: "nowrap" }}>Dia</TableCell>
                                <TableCell style={{ whiteSpace: "nowrap" }}>Horário</TableCell>
                                <TableCell>Pessoa</TableCell>
                                <TableCell>Onde</TableCell>
                                <TableCell>O que foi feito</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {linhas.map((h) => (
                                <TableRow key={h.id}>
                                    <TableCell style={{ whiteSpace: "nowrap" }}>{h.data}</TableCell>
                                    <TableCell style={{ whiteSpace: "nowrap" }}>{h.hora}</TableCell>
                                    <TableCell>{h.usuario}</TableCell>
                                    <TableCell style={{ whiteSpace: "nowrap" }}>{h.acao_rotulo}</TableCell>
                                    <TableCell>
                                        {h.alteracoes && h.alteracoes.length > 0 && h.acao !== "criada" ? (
                                            <ul style={{ margin: 0, paddingLeft: 18 }}>
                                                {h.alteracoes.map((a) => (
                                                    <li key={a.campo}>
                                                        <b>{a.rotulo}:</b> {a.antes} → {a.depois}
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : h.descricao}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            )}
        </div>
    );
};

export default HistoricoModificacoes;
